module.exports = {"230205001":"新兴街道","230205002":"新建街道","230205005":"林机街道","230205006":"道北街道","230205100":"水师营满族镇","230205101":"榆树屯镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/230205.json
// module id = 693
// module chunks = 0